import styled, { css } from 'styled-components';
import { Icon } from '@hey-car/ui';

import { color, media } from 'app/shared/styles_js/variables';

export const DummyPickerWrapper = styled.div`
  position: relative;
  display: flex;
  height: 88px;
  flex-direction: column;
  align-items: center;

  &::after {
    position: absolute;
    bottom: 0;
    left: 8px;
    display: inline-block;
    width: calc(100% - 16px);
    height: 2px;
    content: '';
    background-color: ${color.grayTable};
    ${media.md(css`
      width: calc(100% - 60px);
      left: 30px;
    `)};
    ${media.lg(css`
      width: calc(100% - 100px);
      left: 50px;
    `)};
    ${media.xl(css`
      width: calc(100% - 56px);
      left: 28px;
    `)};
  }
`;

export const DummyPickerInnerWrapper = styled.div`
  display: flex;
  width: 95%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  padding-bottom: 24px;
  margin: 0 auto;

  ${media.md(css`
    width: 75%;
    justify-content: center;
  `)};

  i {
    display: flex;
    height: 100%;

    align-items: center;

    &:first-child {
      padding-right: 30px;
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
      padding-left: 30px;
    }

    ${media.md(css`
      &:first-child {
        padding-right: 40px;
      }

      &:last-child {
        padding-left: 40px;
      }
    `)};
  }

  span {
    display: inline-flex;
    width: 155px;
    height: 40px;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-size: 16px;
    font-weight: bold;
    white-space: pre;
  }
`;

export const IconSt = styled(Icon)`
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${color.gray};
      &:hover {
        color: ${color.gray};
      }
    `}
`;
